<script setup lang="ts">
import TheFooter from '../../../core/components/theFooter/TheFooter.vue';
import SharedHeader from '../../../core/components/SharedHeader.vue';
</script>

<template>
  <div class="single-panel-layout">
    <SharedHeader :should-show-print-button="false" />
    <div class="panel-wrapper">
      <div class="panel-content">
        <slot />
      </div>
    </div>
    <TheFooter class="footer" />
  </div>
</template>

<style scoped lang="scss">
.single-panel-layout {
  background-color: var(--color-off-white);
  display: flex;
  flex-direction: column;

  min-height: 100vh;
  min-height: 100dvh;
  min-width: 100%;
  .panel-wrapper {
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: var(--spacing-24);
    max-width: var(--layout-width);
    margin: 0 auto var(--spacing-32) auto;
    padding: var(--spacing-32) var(--spacing-24) 0;

    @include for-less-or-equal-than-599-px {
      padding-right: 0;
      padding-left: 0;
    }

    .panel-content {
      display: flex;
      flex-direction: column;
      gap: var(--spacing-16);
    }
  }

  .footer {
    margin-top: auto;
  }
}
</style>

<style lang="scss">
.single-panel-layout {
  box-sizing: border-box;

  * {
    box-sizing: border-box;
  }
}
</style>
